<template>
    <!--@touchmove.prevent-->
    <div id="app">
        <!--<keep-alive>-->
            <router-view></router-view>
        <!--</keep-alive>-->
    </div>
</template>

<script>
    export default {}
</script>

<style>

</style>



// WEBPACK FOOTER //
// App.vue?7ab39698